import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import Navbar2 from '../../components/Navbar2/Navbar2';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Bg from '../../images/page-title/bg-4.jpg'
import { useParams } from 'react-router-dom'
import Footer from '../../components/footer/Footer';
import Team from '../../api/products'


const TeamSinglePage = (props) => {
    const { slug } = useParams()

    const TeamDetails = Team.find(item => item.slug === slug)

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }


    return (
        <Fragment>
            <div className='page-wrapper'>
                <Navbar2 hclass={'header-style-2'} />
                <PageTitle pageTitle={TeamDetails.name} pagesub={'Products'} Bg={Bg} />
                <div className="team-single-page separator-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-6 col-lg-6">
                                <div className="team-single-sidebar brder">
                                    <div className="team-item">
                                        <div className="team-img ">
                                            <img src={TeamDetails.tImg} alt="" />
                                        </div>                                        
                                    </div>                                   
                                  
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-6 ">
                                <div className="team-single-content">
                                    <h2>{TeamDetails.name}</h2>
                                    <p>Global Business Head of consultees. Leads the global expansion of the consultees brand
                                        and overseas investment in solutions and innovation. Renowned coder and an authority on
                                        matters of industrial experience, and technological interface.</p>
                                    <p>Expertise in Team management, Performance Improvement, Transformation, Transformation
                                        Catalyst. We consider drawing leads to greater results. We share knowledge, tools, and
                                        resources to get the best desirable outcomes for our clients, our firm and our people.
                                        We are dedicated to producing measured value and results.</p> </div>
                            </div>
                        </div>
                    </div>

                    <div className="team-section separator-padding">
            <div className="container">
                <div className="team-wrap p-0 ">
                    <div className="row">
                        {Team.map((team, aitem) => (
                            <div className="col-lg-4 col-sm-6 col-12" key={aitem}>
                                <div className="team-item mb-3 ">
                                    <div className="team-img">
                                        <img src={team.tImg} alt="" />
                                    </div>
                                    <div className="team-text">
                                        <h3><Link onClick={ClickHandler} to={`/products/${team.slug}`}>{team.name}</Link></h3>
                                        <span>{team.title}</span>
                                    </div>
                                    <div className="right-title">
                                        <h3>{team.name}</h3>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
        
        
         </div>
              
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    )
};
export default TeamSinglePage;
